import emailjs from "@emailjs/browser";

// 送信先の種類。呼び出し側はこのキーだけを意識すればよい
// （プロバイダ固有のテンプレートID等はこのファイル内で解決する）
// CUSTOMER: お客様への自動返信、ADMIN: 運営への通知
export const MAIL_TYPES = {
  INQUIRY_CUSTOMER: "inquiry_customer",
  INQUIRY_ADMIN: "inquiry_admin",
  ORDER_CUSTOMER: "order_customer",
  ORDER_ADMIN: "order_admin",
};

// メール送信プロバイダ。 "emailjs"（既定） または "aws"
const PROVIDER = process.env.VUE_APP_MAIL_PROVIDER || "emailjs";

// --- EmailJS設定 ---
const EMAILJS_SERVICE_ID = process.env.VUE_APP_EMAILJS_SERVICE_ID;
const EMAILJS_PUBLIC_KEY = process.env.VUE_APP_EMAILJS_PUBLIC_KEY;
const EMAILJS_TEMPLATE_IDS = {
  [MAIL_TYPES.INQUIRY_CUSTOMER]: process.env.VUE_APP_EMAILJS_TEMPLATE_ID_INQUIRY_CUSTOMER,
  [MAIL_TYPES.INQUIRY_ADMIN]: process.env.VUE_APP_EMAILJS_TEMPLATE_ID_INQUIRY_ADMIN,
  [MAIL_TYPES.ORDER_CUSTOMER]: process.env.VUE_APP_EMAILJS_TEMPLATE_ID_ORDER_CUSTOMER,
  [MAIL_TYPES.ORDER_ADMIN]: process.env.VUE_APP_EMAILJS_TEMPLATE_ID_ORDER_ADMIN,
};

// --- AWS設定（SES等を呼び出すAPIのエンドポイント） ---
// SESはAPIキー(AWS認証情報)が必要でブラウザから直接呼べないため、
// Lambda + API Gatewayなどで用意したエンドポイントを叩く想定
const AWS_MAIL_API_URL = process.env.VUE_APP_AWS_MAIL_API_URL;
const AWS_MAIL_API_KEY = process.env.VUE_APP_AWS_MAIL_API_KEY;

// 設定が揃っていて実送信できる状態かどうか
export function isMailConfigured() {
  if (PROVIDER === "aws") {
    return Boolean(AWS_MAIL_API_URL);
  }
  return Boolean(EMAILJS_SERVICE_ID && EMAILJS_PUBLIC_KEY);
}

/**
 * メールを送信する。
 * .envが未設定の場合は実送信せず、コンソールに警告を出して終了する
 * （後から.envに値を設定するだけで実送信に切り替わる）。
 *
 * @param {string} mailType MAIL_TYPESのいずれか（送信先テンプレートの種類）
 * @param {Object} templateParams テンプレートに渡すパラメータ
 */
export async function sendMail(mailType, templateParams) {
  if (!isMailConfigured()) {
    console.warn(
      "[mailer] メール送信先が未設定のため、メール送信をスキップしました。",
      { provider: PROVIDER, mailType, templateParams }
    );
    return { status: 0, text: "SKIPPED" };
  }

  if (PROVIDER === "aws") {
    return sendViaAws(mailType, templateParams);
  }
  return sendViaEmailJs(mailType, templateParams);
}

async function sendViaEmailJs(mailType, templateParams) {
  const templateId = EMAILJS_TEMPLATE_IDS[mailType];
  if (!templateId) {
    console.warn(
      "[mailer] EmailJSのテンプレートIDが未設定のため、メール送信をスキップしました。",
      { mailType, templateParams }
    );
    return { status: 0, text: "SKIPPED" };
  }

  return emailjs.send(EMAILJS_SERVICE_ID, templateId, templateParams, {
    publicKey: EMAILJS_PUBLIC_KEY,
  });
}

async function sendViaAws(mailType, templateParams) {
  const headers = { "Content-Type": "application/json" };
  if (AWS_MAIL_API_KEY) {
    headers["x-api-key"] = AWS_MAIL_API_KEY;
  }

  const response = await fetch(AWS_MAIL_API_URL, {
    method: "POST",
    headers,
    body: JSON.stringify({ mailType, templateParams }),
  });

  if (!response.ok) {
    throw new Error(`[mailer] AWSメール送信APIがエラーを返しました: ${response.status}`);
  }

  return response.json().catch(() => ({}));
}
